<template>
  <GlobalWindow
    :title="`配置${module.name}字段`"
    :visible.sync="visible"
    width="1000px"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <ul>
      <li><el-button type="primary" size="mini" @click="addFieldRow">添加行</el-button></li>
    </ul>
    <el-table
      :data="fields"
      stripe
    >
      <el-table-column prop="name" label="字段类型" min-width="140px">
        <FieldTypeSelect
          slot-scope="{row}"
          placeholder="请选择字段类型"
          v-model="row.fieldType"
          @change="fillRowByType(row, $event)"
        />
      </el-table-column>
      <el-table-column prop="variable" label="字段英文名称" min-width="140px">
        <el-input slot-scope="{row}" placeholder="请输入字段变量" v-model="row.variable"/>
      </el-table-column>
      <el-table-column prop="name" label="字段中文名称" min-width="100px">
        <el-input slot-scope="{row}" placeholder="请输入字段名称" v-model="row.label"/>
      </el-table-column>
      <el-table-column prop="required" label="搜索条件" min-width="60px" align="center">
        <el-checkbox slot-scope="{row}" :disabled="row.dataType === 'IMAGE'" v-model="row.isQueryField"/>
      </el-table-column>
      <el-table-column prop="required" label="新建&编辑字段" min-width="100px" align="center">
        <el-checkbox slot-scope="{row}" v-model="row.isCreateField"/>
      </el-table-column>
      <el-table-column prop="required" label="新建&编辑是否必填" min-width="120px" align="center">
        <el-checkbox slot-scope="{row}" v-model="row.required"/>
      </el-table-column>
<!--      <el-table-column prop="fixed" label="固定" min-width="60px" align="center">-->
<!--        <el-checkbox slot-scope="{row}" v-model="row.fixed"/>-->
<!--      </el-table-column>-->
      <el-table-column
        label="操作"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="{$index}">
          <el-button type="text" :disabled="$index === 0" @click="sort('top', $index)" icon="el-icon-sort-up">上移</el-button>
          <el-button type="text" :disabled="$index === fields.length - 1" @click="sort('bottom', $index)" icon="el-icon-sort-down">下移</el-button>
          <el-button type="text" @click="deleteField($index)" icon="el-icon-delete">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import FieldTypeSelect from '../common/FieldTypeSelect'
export default {
  name: 'OperaModuleFieldConfigWindow',
  extends: BaseOpera,
  components: { FieldTypeSelect, GlobalWindow },
  data () {
    return {
      form: {
        id: null,
        fieldConfig: ''
      },
      module: {},
      fields: []
    }
  },
  watch: {
    fields () {
      this.form.fieldConfig = JSON.stringify(this.fields)
    }
  },
  methods: {
    /**
     * 打开窗口
     */
    open (module) {
      this.module = module
      this.visible = true
      this.form.id = module.id
      this.form.fieldConfig = module.fieldConfig
      this.fields = []
      try {
        if (this.form.fieldConfig != null && this.form.fieldConfig !== '') {
          this.fields = JSON.parse(this.form.fieldConfig)
          this.fields = this.fields.map(item => {
            return {
              ...item,
              // 字段类型可能是个字符串，此时需要解析成数组
              fieldType: typeof item.fieldType === 'string' ? JSON.parse(item.fieldType) : item.fieldType
            }
          })
        }
      } catch (e) {
        this.fields = []
      }
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      if (!this.__check()) {
        return
      }
      this.form.fieldConfig = JSON.stringify(this.fields)
      this.__confirmEdit()
    },
    // 排序
    sort (direction, rowIndex) {
      // 上移&下移
      if (direction === 'top') {
        this.fields.splice(rowIndex, 0, this.fields.splice(rowIndex - 1, 1)[0])
      } else {
        this.fields.splice(rowIndex, 0, this.fields.splice(rowIndex + 1, 1)[0])
      }
    },
    // 根据类型填充行
    fillRowByType (row, type) {
      row.dataType = type.type
      row.variable = type.variable
      row.label = type.label
      if (row.dataType === 'IMAGE') {
        row.isQueryField = false
      }
    },
    // 添加字段行
    addFieldRow () {
      this.fields.push({
        fieldType: null,
        dataType: null,
        variable: '',
        label: '',
        required: true,
        isQueryField: true,
        isCreateField: true,
        fixed: true
      })
    },
    // 删除字段行
    deleteField (index) {
      const field = this.fields[index]
      if (field.variable.trim() === '' && field.label.trim() === '') {
        this.fields.splice(index, 1)
        return
      }
      let message = `确认删除【${field.variable.trim()}】字段配置吗`
      if (field.label.trim() !== '') {
        message = `确认删除【${field.label.trim()}】字段配置吗`
      }
      this.$dialog.deleteConfirm(message)
        .then(() => {
          this.fields.splice(index, 1)
        })
        .catch(() => {})
    },
    /**
     * 确认新建
     *
     * @private
     */
    __confirmCreate () {
      this.isWorking = true
      this.api.create(this.form)
        .then(() => {
          this.visible = false
          this.$tip.apiSuccess('新建成功')
          this.$emit('success')
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking = false
        })
    },
    /**
     * 确认修改
     *
     * @private
     */
    __confirmEdit () {
      this.isWorking = true
      this.api.updateById(this.form)
        .then(() => {
          this.visible = false
          this.$tip.apiSuccess('修改成功')
          this.$emit('success')
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking = false
        })
    },
    // 验证字段配置是否合法
    __check () {
      // 必填验证
      for (const field of this.fields) {
        if (field.fieldType == null) {
          this.$tip.warning('请选择字段类型')
          return false
        }
        if (field.variable.trim().length === 0) {
          this.$tip.warning('请输入字段英文名称')
          return false
        }
        if (field.label.trim().length === 0) {
          this.$tip.warning('请输入字段中文名称')
          return false
        }
      }
      // 格式验证
      for (const field of this.fields) {
        if (field.variable.length < 3) {
          this.$tip.warning('英文名称必须大于2个字符')
          return false
        }
        if (!/^[a-z]+[a-z0-9_]+$/.test(field.variable)) {
          this.$tip.warning('英文名称必须为小写字母，特殊字符仅允许使用"_"，且不能以"_"和数字开头')
          return false
        }
      }
      // 英文名称重复验证
      for (const field of this.fields) {
        if (this.fields.filter(f => f.variable === field.variable).length > 1) {
          this.$tip.warning('字段英文名称不可重复')
          return false
        }
      }
      // 中文名称重复验证
      for (const field of this.fields) {
        if (this.fields.filter(f => f.label === field.label).length > 1) {
          this.$tip.warning('字段中文名称不可重复')
          return false
        }
      }
      // 至少有一个为固定字段
      // if (this.fields.filter(f => f.fixed).length === 0) {
      //   this.$tip.warning('至少需要配置一个固定字段')
      //   return false
      // }
      return true
    }
  },
  created () {
    this.config({
      api: '/module/management'
    })
  }
}
</script>

<style scoped>

</style>
